export default __webpack_public_path__ + "static/media/kristina.b9d23065.png";